import {Component} from '@angular/core';
import {AuthService} from '../../../Shared/Services/auth.service';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {Subject} from 'rxjs/internal/Subject';
import {NgxSpinnerService} from 'ngx-spinner';
import {Router} from '@angular/router';
import {UserType} from '../../../Shared/Enums/UserType';
import {LoginVm} from '../../../Model/LoginVM';
import {CustomToastrService} from '../../../Shared/Services/custom-toastr.service';
import {DialogService} from '../../../Shared/Services/dialog.service';
import {environment} from '../../../../environments/environment';
import {ItemsService} from '../../../Services/items.service';
import {itemsVM} from '../../../Model/items/itemsVM';
import {ViewItemComponent} from '../view-item/view-item.component';
import {ShowImageComponent} from '../../../Shared/Components/show-image/show-image.component';
import {SuppliersService} from "../../../Services/suppliers.service";
import {DtoAgentVM} from "../../../Model/agents/DtoAgentVM";
import {forkJoin} from "rxjs";

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrl: './items.component.scss'
})
export class ItemsComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private supplierChanged = new Subject<any>();
  AllItems: itemsVM[] = [];
  AllSuppliers: DtoAgentVM[] = [];
  OriginalItems: itemsVM[] = [];
  FilteredItems: itemsVM[] = [];
  selectedSupplier: DtoAgentVM | null = null;
  searchVal: string = '';
  currentUser: LoginVm = {};
  showEdit: boolean = false;
  imgPath: string = environment.ImgUrl;

  constructor(private api: ItemsService, private supplierService: SuppliersService, private auth: AuthService, private spinner: NgxSpinnerService,
              private router: Router, private toastrService: CustomToastrService, private dialogService: DialogService) {
    this.supplierChanged.pipe(takeUntil(this.destroy$)).subscribe((supplier) => {
      this.selectedSupplier = supplier;
      this.FilteredItems = this.OriginalItems.filter(i => i.supplierId === supplier.id);
      this.AllItems = this.FilteredItems;
    });
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent])) {
      this.spinner.show();
      this.GetCurrentUser();
      this.GetDropDowns();
      this.showEdit = this.currentUser?.userType == UserType.Agent;
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  EditItem(itemId?: number) {
    this.router.navigateByUrl('dashboard/edit-item/' + itemId);
  }

  ViewItem(itemId?: number) {
    const data = {'selectedId': itemId};
    this.dialogService.openDialog(ViewItemComponent, data);
  }

  DeleteItem(itemId?: number) {
    this.dialogService.confirmDialog({
      titleKey: 'confirmation',
      messageKey: 'AreYouSuretoDeleteThis',
      confirmTextKey: 'Yes',
      cancelTextKey: 'No'
    }).subscribe(isConfirmed => {
      if (isConfirmed) {
        this.spinner.show();
        this.ConfirmDeleteItem(itemId);
      }
    });
  }

  ConfirmDeleteItem(itemId?: number) {
    this.api.DeleteItem(itemId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          this.toastrService.showSuccessToast('Success', "DeletedSuccessfully");
          this.GetDropDowns();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
  }

  GetDropDowns(): void {
    this.supplierService.GetAllSuppliers()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (res: any) => {
            this.AllSuppliers = res.result.payload;
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin])) {
      let requests = [this.supplierService.GetAllSuppliers(), this.api.GetAllItemsByUserLogin()];
      forkJoin(requests).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.AllSuppliers = res[0].result.payload;
          this.OriginalItems = res[1].payload;
          this.AllSuppliers = this.AllSuppliers.filter(s => {
            return this.OriginalItems.some(i => i.supplierId == s.id);
          });
          if(this.AllSuppliers.length > 0){
            this.selectedSupplier = this.AllSuppliers[0];
            this.ChangeSupplier(this.selectedSupplier);
          }
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
      });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetFilteredList(event: any) {
    this.AllItems = [];
    if (event.list?.length > 0) {
      this.AllItems = event.list;
    }
  }

  ShowImage(item?: any) {
    const data = {'title': item.productName, 'pathImage': this.imgPath + "/" + item.ImgUrl};
    this.dialogService.openDialog(ShowImageComponent, data);
  }

  ChangeSupplier(supplier: any): void {
    this.supplierChanged.next(supplier);
  }
}

